import React from 'react';

const LiquidityMiningTagMobile = () => {
  return (
    (<svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="LiquidityMiningTagMobile">
      <rect width="22" height="22" rx="5" fill="#232F3A" />
      <path
        d="M9.5701 5L18 9.10946V13.2189L9.5701 17.3284V13.2189L13.7851 11.1642L9.5701 9.10946V5Z"
        fill="#FFC900"
      />
      <path d="M8.21497 9.10953V13.219L4 11.1643L8.21497 9.10953Z" fill="#FFC900" />
    </svg>)
  );
};

export default LiquidityMiningTagMobile;
